import { Outlet, useSearchParams } from "react-router-dom";
import { Affix, Space, Divider, Button, Tag as AntdTag, Popover } from "antd";
import { Icon } from "@terminus/dqh-web-ui";
import { SimpleBusinessSearch } from "./search";
import { Header } from "./head";
import { Footer } from "./footer";
import styles from "./style.module.scss";
import { useEffect, useState } from "react";
import { Tag } from "@/components";
import {
  getMemberCompanyInfo,
  getSiteDomainInfo,
  getCompanyInfoInGroup,
  createSubscribeRuleDebug,
} from "@/services";
import { cancelSubscribeCorporation } from "@/services/business";
import { BusinessCompanyInfoType, CompanyInfoInGroupItemType } from "@/types";
import { useCurrent } from "@/providers";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { RecommendOnselfModal } from "@/components/recommendOnselfModal";
import PayModal from "@/components/payModal";

export const SimplePortalLayout = () => {
  const navigate = useNavigate();
  const { role, isLogin,memberQuotaBase } = useCurrent();
  const [showRecommendOnselfModal, setShowRecommendOnselfModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [recommendOnselfMemberId, setRecommendOnselfMemberId] = useState<any>();
  const isSupplier = role === "supplier";
  const [memberCompanyInfo, setMemberCompanyInfo] =
    useState<BusinessCompanyInfoType>();
  const [companyInfoInGroup, setCompanyInfoInGroup] = useState<
    CompanyInfoInGroupItemType[]
  >([]);
  const [result, setResult] = useState({
    memberId: "",
    companyId: "",
    groupId: "",
    companyName: "",
    groupName: "",
  });
  const [showCompanyDetail, setShowCompanyDetail] = useState(false);
  const [searchParams] = useSearchParams();

  // 类型转换：将 string | null 转换为 string | undefined
  const memberId = searchParams.get("memberId") || undefined;
  const companyId = searchParams.get("companyId") || undefined;
  const groupId = searchParams.get("groupId") || undefined;
  const companyName = searchParams.get("companyName") || undefined;
  const groupName = searchParams.get("groupName") || undefined;
  const enterpriseKey = searchParams.get("enterpriseKey") || undefined;

  useEffect(() => {
    if (!memberId && !groupId && !companyName) {
      fetchSiteDomainInfo();
      return;
    } else {
      fetchInitData({
        memberId: memberId || undefined,
        groupId: groupId || undefined,
        companyName: companyName || undefined,
        groupName: groupName || undefined,
      });
    }
  }, [memberId, companyId]);

  const fetchInitData = async ({
    memberId,
    companyId,
    groupId,
    companyName,
    groupName,
  }: {
    memberId?: string;
    companyId?: string;
    groupId?: string;
    companyName?: string;
    groupName?: string;
  }) => {
    setResult({
      memberId: memberId || "",
      companyId: companyId || "",
      groupId: groupId || "",
      companyName: companyName || "",
      groupName: groupName || "",
    });
    try {
      const res = await getMemberCompanyInfo({
        memberId,
        companyId,
        groupId,
        companyName,
      });
      console.log(res, "getMemberCompanyInfo--123");
      const newSearchParams = new URLSearchParams();
      setResult((pre) => ({
        ...pre,
        enterpriseKey: res?.enterpriseKey || enterpriseKey,
      }));
      if (memberId) newSearchParams.set("memberId", memberId);
      if (companyId) newSearchParams.set("companyId", companyId);
      if (groupId) newSearchParams.set("groupId", groupId);
      if (companyName) newSearchParams.set("companyName", companyName);

      if (res?.companyName) {
        newSearchParams.set("companyName", res.companyName);
      }
      if (res?.groupName) {
        newSearchParams.set("groupName", res.groupName);
      }
      navigate(`?${newSearchParams.toString()}`, { replace: true });
      setMemberCompanyInfo(res);
      if (groupId || memberId) {
        const group = await getCompanyInfoInGroup({
          groupId: groupId || undefined,
          memberId: memberId || undefined,
        });
        setCompanyInfoInGroup(group);
      }
    } catch (error) {}
  };

  const fetchSiteDomainInfo = async () => {
    const res = await getSiteDomainInfo();
    const { memberId, companyId, groupId } = res;
    fetchInitData({
      memberId: memberId || undefined,
      companyId: companyId || undefined,
      groupId: groupId || undefined,
      companyName: companyName || undefined,
    });
  };
  const refreshCompanyInfo = async () => {
    if (groupId || memberId) {
      const group = await getCompanyInfoInGroup({
        groupId: groupId || undefined,
        memberId: memberId || undefined,
      });
      setCompanyInfoInGroup(group);
    }
  };

  const handleSubscribe = async (item: any) => {
    if (!isLogin) {
      window.location.href = `${
        process.env.LOGIN_URL
      }?gotoUrl=${encodeURIComponent(window.location.href)}`;
      return;
    }
    try {
      const params = {
        type: "CORPORATION" as const,
        buyerMemberId: item?.companyId || item.memberId || "",
      };
      if (item?.subscribe) {
        await cancelSubscribeCorporation({
          buyerMemberId: item?.companyId || item.memberId || "",
        });
        message.success("取消订阅成功");
      } else {
        await createSubscribeRuleDebug(params);
        message.success("订阅成功");
      }
      await fetchInitData({
        memberId,
        companyId,
        groupId,
      });
    } catch (error: any) {
      console.log(error, "error");
      // message.error("订阅失败，请稍后重试");
    }
  };
  const formatValue = (value: any) => {
    const { groupId, companyId, memberId, companyName } = value || {};
    const params = [];
    if (
      (!groupId || groupId === "null") &&
      (!companyId || companyId === "null") &&
      (!memberId || memberId === "null")
    ) {
      return `?companyName=${companyName}`;
    }
    if (groupId && groupId !== "null") {
      params.push(`groupId=${groupId}`);
    }
    if (companyId && companyId !== "null") {
      params.push(`companyId=${companyId}`);
    }
    if (memberId && memberId !== "null") {
      params.push(`memberId=${memberId}`);
    }
    return params.length > 0 ? `?${params.join("&")}` : "";
  };
  return (
    <>
      <div className={styles.globalWrapper}>
        <Affix style={{ zIndex: 1000 }}>
          <div>
            <Header noTabs />
            <SimpleBusinessSearch
              companyInfo={memberCompanyInfo}
              showCompanyDetail={showCompanyDetail}
              type={"portal"}
              onOpenCompanyDetail={() => {
                setShowCompanyDetail((val) => !val);
              }}
              isGroup={!!result?.groupId && !!result?.groupName}
              value={{
                companyId: result?.companyId,
                memberId: result?.memberId,
                groupId: result?.groupId,
              }}
              handleSubscribe={handleSubscribe}
              showDetailDrop={
                !!memberCompanyInfo?.companySummary ||
                !!companyInfoInGroup?.length
              }
            />
          </div>
        </Affix>
        {showCompanyDetail &&
          (memberCompanyInfo?.companySummary || !!companyInfoInGroup?.length) && (
            <div className={styles.companyDetailWrapper}>
              <div className={styles.companyDetailContent}>
                <div className={styles.companyDetailHeader}>
                  {/* <div className={styles.companyDetailHeaderTitle}>
                  {memberCompanyInfo?.companyName}
                </div> */}
                  <div className={styles.companyDetailHeaderSub}>
                    {memberCompanyInfo?.companySummary}
                  </div>
                </div>
                {companyInfoInGroup.length > 0 && (
                  <div className={styles.companyDetailContentMain}>
                    <div className={styles.companyDetailListHeader}>
                      <div className={styles.headerItem1}>企业信息</div>
                      <div className={styles.headerItem2}>法人</div>
                      <div className={styles.headerItem3}>成立日期</div>
                      <div className={styles.headerItem4}>营业日期</div>
                      <div className={styles.headerItem5}></div>
                    </div>
                    {companyInfoInGroup.map((item, index) => {
                      return (
                        <div
                          className={styles.companyDetailListContent}
                          key={index}
                        >
                          <div className={styles.listHead}>
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigate(`${formatValue(item)}`);
                              }}
                              className={
                                styles.headerItem1 + " " + styles.listHeadItem
                              }
                            >
                              {item.companyName}
                            </div>
                            <div className={styles.headerItem2}>
                              {item.legalPerson}
                            </div>
                            <div className={styles.headerItem3}>
                              {item.operationStartdate}
                            </div>
                            <div className={styles.headerItem4}>
                              {item.operationEnddate
                                ? `${item.operationStartdate} 至 ${item.operationEnddate}`
                                : item.operationStartdate}
                            </div>
                            <div className={styles.headerItem5}>
                              <Space>
                                {/* <Popover
                                content={
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: 100,
                                        height: 100,
                                        marginBottom: 8,
                                      }}
                                      alt=""
                                      src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/dingding_qr.png"
                                    />
                                    <span
                                      style={{ color: "#1f2024", fontSize: 12 }}
                                    >
                                      钉钉扫码
                                    </span>
                                    <span
                                      style={{ color: "#1f2024", fontSize: 12 }}
                                    >
                                      立即咨询
                                    </span>
                                  </div>
                                }
                              >
                                <Button type="link">
                                  <img
                                    src={collaboratConsult}
                                    alt="合作咨询"
                                    style={{
                                      width: 16,
                                      height: 16,
                                      marginRight: 4,
                                      verticalAlign: "middle",
                                    }}
                                  />
                                  合作咨询
                                </Button>
                              </Popover> */}
                              <div style={{display: 'flex', alignItems: 'center', gap: 2,fontSize:14,color:'#FF5600',cursor:'pointer',lineHeight:22,flexWrap:'nowrap'}} onClick={() => {
                                if(!memberQuotaBase) {
                                  setShowPayModal(true);
                                  return;
                                }
                                setShowRecommendOnselfModal(true);
                                setRecommendOnselfMemberId(item?.memberId);
                              }}>
                                <img src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/recommendSelf.png" style={{width: 16, height: 16}} />
                                供应商自荐
                              </div>
                                {(isSupplier || !isLogin) && (
                                  <>
                                    <Divider type="vertical" />
                                    {item.subscribe ? (
                                      <Button
                                        type="link"
                                        onClick={() => {
                                          handleSubscribe(item);
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          color: "rgb(165, 165, 165)",
                                        }}
                                      >
                                        <Icon
                                          name="shangjikapian-yidingyue"
                                          size={16}
                                          style={{ marginRight: 2 }}
                                        />
                                        已订阅
                                      </Button>
                                    ) : (
                                      <Button
                                        type="link"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        onClick={() => {
                                          handleSubscribe(item);
                                        }}
                                      >
                                        <img
                                          src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/orderCompany.png"
                                          alt="订阅企业"
                                          style={{
                                            width: 16,
                                            height: 16,
                                            marginRight: 2,
                                            verticalAlign: "middle",
                                          }}
                                        />
                                        订阅企业
                                      </Button>
                                    )}
                                  </>
                                )}
                              </Space>
                            </div>
                          </div>
                          <div className={styles.listTagWrap}>
                            {/* <img
                              src={
                                "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/bigCompany_icon.png"
                              }
                              alt=""
                            /> */}
                            {/* {item.realNameAuthed && (
                              <Tag
                                type="normal"
                                style={{
                                  background: "#fff",
                                  color: "#4CA5E8",
                                  borderColor: "#4CA5E8",
                                  margin: 0,
                                }}
                                title="实名认证"
                                icon="yishiming"
                              />
                            )} */}
                            {item.operationTagNameList &&
                              item.operationTagNameList.map((tag, index) => {
                                if (tag === "独家签约企业" || tag === "签约企业") {
                                  const isExclusive = tag === "独家签约企业";
                                  return (
                                    <img
                                      key={index}
                                      src={
                                        isExclusive
                                          ? "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/dujiaqysj.svg"
                                          : "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/qianyuesj.svg"
                                      }
                                      style={{
                                        width: isExclusive ? 88 : 64,
                                        height: 22,
                                      }}
                                      alt={tag}
                                    />
                                  );
                                }

                                return (
                                  <AntdTag
                                    key={index}
                                    style={{ color: "#FF5600", margin: "0" }}
                                    color="rgba(255, 86, 0, 0.2)"
                                  >
                                    {tag}
                                  </AntdTag>
                                );
                              })}
                            {item.autoTagNameList &&
                              item.autoTagNameList.map((tag, index) => {
                                return <AntdTag key={index}>{tag}</AntdTag>;
                              })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}

        <div className={styles.outLayoutWrapper}>
          <div className={styles.layoutWrapper}>
            <div className={styles.layoutContent}>
              <Outlet
                context={{
                  supplierInfo: memberCompanyInfo,
                  ...result,
                  groupName: result?.groupName || groupName,
                  companyName: result?.companyName || companyName,
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ width: 1200, margin: "0 auto" }}>
          <Footer />
        </div>
      </div>
      <PayModal open={showPayModal} onCancel={() => setShowPayModal(false)} onOk={() => setShowPayModal(false)} />
      <RecommendOnselfModal visible={showRecommendOnselfModal} setVisible={setShowRecommendOnselfModal} memberId={recommendOnselfMemberId} />
    </>
  );
};
